module.exports = __webpack_public_path__ + "img/hands-praying.5f9acae0.svg";